module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Content_Browser #dl":{"hooks.onStopLoaded":[{"value":function () {
var parent = this.getParent();
if (!parent.getOption('useGeneratedContentLink')) {
return;
};
parent.generateContentLink();
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101008},"path":"~.Content_Browser #dl","_fox_":1}]},"~.Content_Scenes":{"preset":[{"value":"videos","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101010},"path":"~.Content_Scenes","_fox_":1}]},"~.Content_Photosets":{"preset":[{"value":"photosets","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"~.Content_Photosets","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/content/browser.js
// module id = 656
// module chunks = 4